<template>
  <v-snackbar v-model="showSnackbar" :timeout="message?.timeout ?? 2500" :color="message?.type">
    <span class="snackbar-text w-100 d-flex justify-center font-weight-bold" :class="{ 'text-left': message?.textAlign === 'left' }">
      {{ message?.text }}
    </span>
  </v-snackbar>
</template>

<script lang="ts">
import { useSnackbarStore } from "~/stores/snackBarStore"

export default {
  setup() {
    const snackbarStore = useSnackbarStore()
    return { snackbarStore }
  },

  data() {
    return {
      showSnackbar: false,
      message: null as null | { text: string; type: "success" | "error"; timeout?: number; textAlign?: "left" | "center" },
    }
  },

  watch: {
    "snackbarStore.messages": {
      handler() {
        this.tryToSetMessage()
      },
      deep: true,
    },

    showSnackbar() {
      this.tryToSetMessage()
    },
  },

  methods: {
    tryToSetMessage() {
      if (this.snackbarStore.messages.length > 0) {
        this.message = this.snackbarStore.messages.pop() as any
        this.showSnackbar = true
      }
    },
  },
}
</script>

<style scoped>
.snackbar-text {
  white-space: pre-line;
  text-align: center;
}

.snackbar-text.text-left {
  text-align: left;
}
</style>
